import React, { useState, useEffect, useMemo } from "react";
import { StcStatusHeader } from "./StcStatusHeader";
import { StcPressureGauges } from "./StcPressureGauges";
import { StcTimeRangeBar } from "./StcTimeRangeBar";
import { StcTimeChart } from "./StcTimeChart";
import { StcPressureHistogram } from "./StcPressureHistogram";
import { StcScatterChart } from "./StcScatterChart";
import { StcTempChart } from "./StcTempChart";

export const StcFetch = () => {
  const [sensorData, setSensorData] = useState(null);
  const [timeRange, setTimeRange] = useState(null);

  useEffect(() => {
    fetch(
      "https://tnmooyflntrajxp34ymztb6rq40qrmlr.lambda-url.eu-west-2.on.aws/"
    )
      .then((res) => res.json())
      .then((data) => setSensorData(data));
  }, []);

  const filteredReadings = useMemo(() => {
    if (!sensorData?.Readings) return null;
    if (timeRange === null) return sensorData.Readings;
    const cutoff = Date.now() - timeRange * 3600000;
    return sensorData.Readings.filter(
      (r) => new Date(r.timestamp).getTime() >= cutoff
    );
  }, [sensorData, timeRange]);

  const latestReading = sensorData?.Readings?.[sensorData.Readings.length - 1];

  const cardStyle = {
    backgroundColor: "#323640",
    borderRadius: 8,
    padding: "8px 0",
    marginBottom: 8,
  };

  return (
    <div
      style={{
        width: "100%",
        maxWidth: 440,
        padding: "0 4px",
        boxSizing: "border-box",
      }}
    >
      <StcStatusHeader lastUpdate={sensorData?.LastUpdate} />

      <StcPressureGauges
        pressure1={latestReading?.pressure_1 ?? null}
        pressure2={latestReading?.pressure_2 ?? null}
      />

      <StcTimeRangeBar selected={timeRange} onSelect={setTimeRange} />

      <div style={cardStyle}>
        <StcTimeChart key={timeRange} readings={filteredReadings} />
      </div>

      <div style={cardStyle}>
        <StcPressureHistogram readings={filteredReadings} />
      </div>

      <div style={cardStyle}>
        <StcScatterChart readings={filteredReadings} />
      </div>

      <div style={cardStyle}>
        <StcTempChart readings={filteredReadings} />
      </div>
    </div>
  );
};
